(function ($) {
  "use strict";

  Drupal.behaviors.wysiwygTables = {
    attach: function (context, settings) {
      //".text-formatted table"
    },
  };

  Drupal.behaviors.defaultPopIn = {
    attach: function (context, settings) {
      $(once("done-defaultPopIn", ".popIn")).each(function () {
        Drupal.popIn($(this));
      });
    },
  };

  Drupal.behaviors.ResizeSlickRefresh = {
    attach: function (context, settings) {
      if (!once("done-ResizeSlickRefresh", "html").length) {
        return;
      }
      const $window = $(window);
      const $slicks = $(".slick--initialized");
      $window.on("resize orientationchange", function () {
        $slicks.each(function (e) {
          $(this).slick.setPosition();
        });
      });
    },
  };

  Drupal.behaviors.backToTop = {
    attach: function (context, settings) {
      let $backToTop = $("#back-to-top");
      let $stickyMenu = $("header");
      $backToTop.click(function (e) {
        e.preventDefault();
        Drupal.scrollToElement($backToTop.attr("href"), $stickyMenu);
      });

      $(window).on("scroll resize load", function () {
        if ($(window).scrollTop() >= 1200) {
          $backToTop.addClass("visible");
        } else {
          $backToTop.removeClass("visible");
        }
      });
    },
  };

  Drupal.behaviors.obsoleteBrowser = {
    attach: function (context, settings) {
      let popupButton = document.getElementById("buorgul");
      if(popupButton){
        popupButton.focus();
      }
    },
  };

  Drupal.behaviors.closeAlert = {
    attach: function (context, settings) {
      let closeButton = document.getElementById("close-status-message");
      let message = document.getElementById("closable-message-status");
      if(closeButton && message){
        closeButton.addEventListener("click", function() {
          message.remove();
        });
      }
    },
  };
})(jQuery, Drupal);
